import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateReportBuilderReportByIdMutation, MutateReportBuilderReportByIdMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'

const document = graphql(/* graphql */`
  mutation mutateReportBuilderReportById($id: MongoID!, $record: UpdateByIdReportBuilderReportInput!) {
    cat {
      reporting {
        builder {
          report {
            updateById(_id: $id, record: $record) {
              recordId
            }
          }
        }
      }
    }
  }
`)

export type UseMutateReportBuilderReportByIdReturn = UseMutationResult<
MutateReportBuilderReportByIdMutation,
unknown,
MutateReportBuilderReportByIdMutationVariables
>

const useMutateReportBuilderReportById = (): UseMutateReportBuilderReportByIdReturn => {
  return useGraphMutation(document)
}

export { useMutateReportBuilderReportById, document as mutateReportBuilderReportByIdDocument }
